'use client'

import classNames from 'classnames'
import { ReactNode, useEffect, useMemo } from 'react'
import eventButtonStyles from '@/app/_components/EventBackButton/EventBackButton.module.css'
import sharedEventStyles from '@/styles/templates/Events.module.css'
import { useSeller } from '@/app/_providers/SellerProvider/SellerProvider'
import { ThemedContainer } from '../ThemedContainer/ThemedContainer'
import EventHeader from '../EventHeader/EventHeader'
import StringToReactNode from '../StringToReactNode/StringToReactNode'
import { getEventMeta, getEventsNotOnSale } from '@/utils/events.utils'
import EventBackButton from '../EventBackButton/EventBackButton'
import TruncatedTextContainer from '../TruncatedTextContainer/TruncatedTextContainer'
import { DESCRIPTION_CHAR_LIMIT } from '@/config/events.config'
import styles from './EventDetails.module.css'
import { useEvent } from '@/app/_providers/EventProvider/EventProvider'
import RelatedEvents from '@/app/_components/EventDetails/RelatedEvents'
import EventDetailsLocationCard from '@/app/_components/EventDetails/LocationCard'
import { safeScroll } from '@/utils/navigation.utils'

const EventsDetails = (): ReactNode => {
  const { timezone, isPreview } = useSeller()
  const primaryEventData = useEvent<Transformed.EventWithTimeslotsAndMeta>()

  const eventsNotOnSaleYet = useMemo(() => (
    getEventsNotOnSale([primaryEventData], timezone)
  ), [primaryEventData, timezone])

  const meta = getEventMeta(primaryEventData.meta)

  const foundEventNotOnSale = eventsNotOnSaleYet?.find((el) => el.id === primaryEventData.id)

  useEffect(() => {
    safeScroll(0)
  }, [])

  return (
    <ThemedContainer theme="dark">
      <EventHeader
        eventOnSale={!foundEventNotOnSale}
        meta={meta}
      />
      <div
        className={classNames(
          sharedEventStyles.EventContainer,
          sharedEventStyles.EventDetails,
        )}
        data-testid="event-details-container"
      >
        <section className={styles.EventDetailsBottom}>
          <EventDetailsLocationCard />
          <RelatedEvents />
          <main
            className={classNames(
              styles.EventDetailsBottomRight,
              'content',
            )}
          >
            {primaryEventData.description && (
              <TruncatedTextContainer
                className="events"
                truncateContent={primaryEventData.description.length > DESCRIPTION_CHAR_LIMIT}
              >
                <StringToReactNode
                  data-testid="event-details-description"
                  className={styles.EventDescription}
                  incomingString={primaryEventData.description}
                />
              </TruncatedTextContainer>
            )}
          </main>
        </section>
      </div>
      {!isPreview && (
        <section className={classNames(styles.BottomSection, eventButtonStyles.BottomSection)}>
          <EventBackButton />
        </section>
      )}
    </ThemedContainer>
  )
}

export default EventsDetails
